import {PublishingOption} from '@Components/ai-chat-window/components/publishing-options/publishing-options.types';
import {LoadingStates} from '@Utils/loading.util';
import {postDesignOnSocialMedia, promoteDesignAsEvent, sendDesignAsEmail} from '@Components/ai-chat-window/lib/publish-design.library';
import {useAiChatActions} from '@AiChat/providers/ai-chat.context';

interface UsePublishChatModelGeneratedImage {
  publishToSocialMedia: () => Promise<void>;
  promoteAsEvent: () => Promise<void>;
  publishAsEmailCampaign: () => Promise<void>;
}

type PublishAction = (imageHashedId: string) => Promise<void>;

export const usePublishChatModelGeneratedImage = (chatId: string, hashedId: string): UsePublishChatModelGeneratedImage => {
  const actions = useAiChatActions();

  const updateLoadingPublishingOption = (loadingOption: PublishingOption | null, loadingState: LoadingStates): void => {
    actions.updateLoadingStatesForImageActions(chatId, hashedId, {
      loadingPublishingOption: loadingOption,
      publishingLoadingState: loadingState,
    });
  };

  const runWithLoadingState = async (option: PublishingOption, publish: PublishAction): Promise<void> => {
    updateLoadingPublishingOption(option, LoadingStates.LOADING);

    try {
      await publish(hashedId);
      updateLoadingPublishingOption(option, LoadingStates.LOADED);
    } catch (e: unknown) {
      console.error(e);
      updateLoadingPublishingOption(null, LoadingStates.NOT_LOADED);
    }
  };

  return {
    publishToSocialMedia: async (): Promise<void> => {
      await runWithLoadingState(PublishingOption.PUBLISH_TO_SOCIAL_MEDIA, postDesignOnSocialMedia);
    },
    promoteAsEvent: async (): Promise<void> => {
      await runWithLoadingState(PublishingOption.PROMOTE_AS_EVENT, promoteDesignAsEvent);
    },
    publishAsEmailCampaign: async (): Promise<void> => {
      await runWithLoadingState(PublishingOption.PUBLISH_AS_EMAIL_CAMPAIGN, sendDesignAsEmail);
    },
  };
};
